/*DATA

const lok=[
  { name: "Lokacija1", children: [2, 3], id: 1, parent: 0,lokacijatip:0 },
  { name: "Toviliste 11", id: 2, parent: 1,lokacijatip:1 },
  { name: "Toviliste 12", id: 3, parent: 1,lokacijatip:1 },
  { name: "Lokacija 2", children: [5, 7], id: 4, parent: 0,lokacijatip:0 },
  { name: "Toviliste 21", children: [6], id: 5, parent: 4,lokacijatip:1 },
  { name: "Odjeljak 211", id: 6, parent: 5,lokacijatip:2 },
  { name: "Odjeljak 212", id: 55, parent: 5,lokacijatip:2 },
  { name: "Toviliste 22", children: [8], id: 7, parent: 4,lokacijatip:1 },
  { name: "Odjeljak 221", id: 8, parent: 7,lokacijatip:2 },
  { name: "Lokacija 3", id: 9, parent: 0,lokacijatip:0 },
  { name: "Lokacija 4", id: 10, parent: 0,lokacijatip:0 },
  { name: "Lokacija 5", id: 11, parent: 0,lokacijatip:0 },

]
*/

import { Box,List,
    ListItem,
    ListIcon,
    Checkbox } from "@chakra-ui/react";
import {ChevronRightIcon, ChevronDownIcon} from "@chakra-ui/icons"
import { useState,useEffect } from "react";

export default function LokacijeSelect({data,onChange,colorscheme="grunt2",componentsize='xs'}){
    
const [state,setState]=useState({data:[],selectedodjeljci:[],dataPrepared:false})

useEffect(() => {
    const prepareData=()=>{
        let _ar=[];
        let _lok;
        
        //lokacije
        data.forEach((element) => {
            if (element.lokacijatip===1) {
                _ar.push({id:element.id,name:element.name,lokacijatip:element.lokacijatip,expanded:false,isChecked:false,isIndeterminante:false,children:[]})
            }
        });
        //tovilista

        data.forEach((toviliste)=>{
            if (toviliste.lokacijatip===2) {
                _lok=_ar.findIndex((item)=>{
                    return item.id===toviliste.parent;
                })
                if (_lok!==-1) {
                    
                    _ar[_lok].children.push({id:toviliste.id,name:toviliste.name,lokacijatip:toviliste.lokacijatip,expanded:false,isChecked:false,isIndeterminante:false,children:[]})
                    
                }

                
            }
        });
        //odjeljci
        data.forEach((odjeljak)=>{
            if (odjeljak.lokacijatip===3) {
                _ar.forEach((r)=>{
                    if (r.children.length>0) {
                        _lok=r.children.findIndex((item)=>item.id===odjeljak.parent);
                        if (_lok!==-1) {
                            r.children[_lok].children.push({id:odjeljak.id,name:odjeljak.name,lokacijatip:odjeljak.lokacijatip,expanded:false,isChecked:false,isIndeterminante:false});
                        }
                    }
                })
            }
        })

        setState({...state,data:_ar,prepareData:true})
    }
    prepareData();
  }, [])

  const onExpandItem=(id)=>{
    let _ar=state.data;
    let _i=_ar.findIndex((item)=>item.id===id);
    if (_i!==-1) {
        _ar[_i].expanded=!_ar[_i].expanded;
    }
    else {
        //tovilišta
        _ar.forEach((lokacija)=>{
            _i=lokacija.children.findIndex((item)=>item.id===id);
            if (_i!==-1) {
                lokacija.children[_i].expanded=!lokacija.children[_i].expanded;
            } else {
                //odjeljci
            }
        })
    }
        
    setState({...state,data:_ar});
    }

    const onCheckItem=(event)=>{
        const _c=event.target.checked;
        const _lokid=Number(event.target.value);
        let _ar=state.data;
        let _i=_ar.findIndex((item)=>item.id===_lokid);
        if (_i!==-1) {
            _ar[_i].isChecked=_c;
            //označavanje tovilišta
            _ar[_i].children.forEach((_it)=>{
                _it.isChecked=_c;
                //označavanje odjelajaka
                _it.children.forEach((_it2)=>{
                    _it2.isChecked=_c;
                })
            })
        } else {
            //tovilišta
            _ar.forEach((lokacija)=>{
                _i=lokacija.children.findIndex((item)=>item.id===_lokid);
                if (_i!==-1) {
                    lokacija.children[_i].isChecked=_c;
                    //označavanje svih odjeljaka
                    lokacija.children[_i].children.forEach((odj)=>{
                        odj.isChecked=_c;
                    })
                } else {
                    //odjeljci
                    lokacija.children.forEach((toviliste)=>{
                        _i=toviliste.children.findIndex((item)=>item.id===_lokid);
                        if (_i!==-1) {
                            toviliste.children[_i].isChecked=_c;
                          
                        }
                    })
                }
            })
        }
        _ar=setisIndeterminate(_ar);
        setState({...state,data:_ar});
        checkSelectedOdjeljci();
    }

    const checkSelectedOdjeljci=()=>{
        const _ar=state.data;
        const _odjeljci=[];
        _ar.forEach((lokacija)=>{
            lokacija.children.forEach((toviliste)=>{
                toviliste.children.forEach((odjeljak)=>{
                    if (odjeljak.isChecked) {
                        _odjeljci.push(odjeljak.id);
                    }
                })
            })
        })

        onChange(_odjeljci);
    }

    const setisIndeterminate=(ar)=>{
        
        let _tovind=false;
        let _lokind=false;
        let _brnechekiranih=0;
        let _brchekiranih=0;
        let _brindenter=0;
        //tovilišta
        ar.forEach((lokacija)=>{
           
            lokacija.children.forEach((toviliste)=>{
                if (toviliste.children.length>0) {
                    _brnechekiranih=0;
                    _brchekiranih=0;
                    toviliste.children.forEach((odjeljak)=>{
                        if (odjeljak.isChecked) {
                        _brchekiranih+=1; 
                        } else {
                            _brnechekiranih+=1;
                        }
                    })
                    if (_brchekiranih===0) {
                        toviliste.isChecked=false;
                        toviliste.isIndeterminante=false;
                    } else if (_brnechekiranih===0) {
                        toviliste.isChecked=true;
                        toviliste.isIndeterminante=false;
                    } else {
                        toviliste.isChecked=false;
                        toviliste.isIndeterminante=true;
                    }

            }
            })
        })

        //lokacije
        ar.forEach((lokacija)=>{
            if (lokacija.children.length>0) {
                
            
                _brnechekiranih=0;
                _brchekiranih=0;
                _brindenter=0;
                lokacija.children.forEach((toviliste)=>{
                    if (toviliste.isChecked && !toviliste.isIndeterminante) {
                        _brchekiranih+=1;
                    } else if (!toviliste.isChecked && !toviliste.isIndeterminante) {
                        _brnechekiranih+=1;
                    } else if (toviliste.isIndeterminante) {
                        _brchekiranih+=1;
                        _brnechekiranih+=1;
                    }
                })
                if ( (_brchekiranih>0 & _brnechekiranih>0)) {
                    lokacija.isChecked=false;
                    lokacija.isIndeterminante=true;
                } else {
                    if (_brnechekiranih===0 && _brchekiranih>0) {
                        lokacija.isChecked=true;
                        lokacija.isIndeterminante=false;
                    } else if (_brchekiranih===0 /*&& _brnechekiranih>0*/) {
                        lokacija.isChecked=false;
                        lokacija.isIndeterminante=false;
                    }
                    else {
                        lokacija.isChecked=false;
                    }
                }
            }
        })

        return ar;
    }
  

const showData=()=>{
    if (state.prepareData) {
        return (
            <List>
               
                {state.data.map((item,index)=>{
                    return (
                    <ListItem _hover={{cursor:'pointer'}} key={item.id} m={'0.3rem'}>
                        <ListIcon fontWeight={'bold'} as={item.expanded?ChevronDownIcon:ChevronRightIcon} onClick={()=>{onExpandItem(item.id)}}/>
                        <Checkbox size={'sm'} colorScheme={colorscheme} value={item.id} isChecked={item.isChecked} isIndeterminate={item.isIndeterminante} onChange={onCheckItem}>{item.name}</Checkbox>
                        <List ml={'1rem'} size={componentsize}>
                            {item.expanded && item.children.map((toviliste,index)=>{
                                return (
                                    <ListItem _hover={{cursor:'pointer'}} key={toviliste.id}>
                                        <ListIcon as={toviliste.expanded?ChevronDownIcon:ChevronRightIcon} onClick={()=>{onExpandItem(toviliste.id)}}/>
                                        <Checkbox size={'sm'} colorScheme={colorscheme} value={toviliste.id} isChecked={toviliste.isChecked} isIndeterminate={toviliste.isIndeterminante} onChange={onCheckItem}>{toviliste.name}</Checkbox>
                                        <List ml={'1rem'} size={componentsize}>
                                            {toviliste.expanded && toviliste.children.map((odjeljak,index)=>{
                                                return (
                                                <ListItem _hover={{cursor:'pointer'}} key={odjeljak.id}>
                                                    <ListIcon as={ChevronRightIcon} bgSize={componentsize}/>
                                                    <Checkbox size={'sm'} colorScheme={colorscheme} value={odjeljak.id}isChecked={odjeljak.isChecked} onChange={onCheckItem}>{odjeljak.name}</Checkbox>
                                                </ListItem>
                                                )
                                            })}
                                        </List>
                                    </ListItem>
                                )
                            })}
                        </List>
                    </ListItem>)
                })}
               
            </List>
        )
    }
    
    
}

return (
    <Box maxH={'60vh'} overflowY={'auto'}>
        {showData()}
        
    </Box>
)

}

